<template>
<div class="img-container">
    <!-- 模糊背景层 -->
    <div 
      class="img-blur-bg"
      :style="{ backgroundImage: `url(${start.heying})` }"
    ></div>
    <!-- 主体图片层 -->
    <img 
      class="main-img"
      :src="start.heying" 
      alt="主体图片"
    />
  </div>
</template>
<style scoped>
/* 在你的组件的<style>标签中 */
@font-face {
  font-family: 'diyfont';
  src: url('~@/assets/font/509.ttf'); /* 使用webpack的别名~@指向src目录 */
  font-weight: normal;
  font-style: normal;
}

body {
  overflow-y: hidden;
}

.machine-table {
  width: 100%;
  /* color: #E3E59D; */
}

.machine-box {
  /* background: #0782B8; */
  text-align: center;
  /* color: #fff; */
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  /*align-items: center; !*使子项目垂直居中*!*/
}

.machine-content {
  margin: 100px 0 0 0
}

.machine-content .machine-subject {
  font-size: 56px;
}

.machine-content .machine-army {
  font-size: 108px;
  margin-top: 40px;
  font-weight: bold;
  font-family: 'sun2';
  color: #ffffffcc;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table th, table td {
  height: 50px;
  font-size: 16px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}

table td a {
  color: #E3E59D;
}

table td a:hover {
  color: #F2EB92;
  text-decoration: underline;
}

table td a.disabled {
  color: #999;
}
table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  color: white;
  background-color: #0782B8;
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:nth-child(2) {
  width: 400px;
}

table tbody td:nth-child(2) {
  width: 400px;
}

table thead th:nth-child(3) {
  width: 360px;
}

table tbody td:nth-child(3) {
  width: 360px;
}

table thead th:nth-child(4) {
  width: 100px;
}

table tbody td:nth-child(4) {
  width: 100px;
}
/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tr:nth-child(even) {
  background: #0782B8;
}

.pointer {
  cursor: pointer;
}


.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


</style>
<script>
export default {
  name: "ScoreStartArmy",
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Array,
      default: []
    }
  },
  components: {},
  data() {
    return {
      scoreList: [],
      formData: {
        id: 0
      },
      thisIndex:0,

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{
    list(){ 
      let that = this
      console.log('watch list')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    },
    start(){ 
      let that = this
      console.log('watch start')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    }
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'
  },
  destroyed() {
  },
  computed: {},
  methods: {

  }
}
</script>

<style scoped>
/* 容器样式 - 占满视口，居中对齐 */
.img-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; /* 作为子元素定位参考 */
}

/* 高斯模糊背景层 */
.img-blur-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: inherit;
  background-size: cover;
  background-position: center;
  filter: blur(20px); /* 模糊程度，可调整 */
  z-index: 1; /* 放在主体图片下方 */
  /* 解决模糊边缘白边问题 */
  transform: scale(1.1);
}

/* 主体图片样式 */
.main-img {
  width: 100%;
  max-height: 100vh; /* 防止图片高度超出视口 */
  object-fit: contain; /* 保持图片比例，完整显示 */
  position: relative;
  z-index: 2; /* 显示在模糊背景上方 */
}

/* 横屏适配优化（可选）- 针对宽屏场景 */
@media (orientation: landscape) {
  .main-img {
    max-height: 95vh; /* 横屏时留少量边距 */
  }
  .img-blur-bg {
    filter: blur(25px); /* 横屏可加大模糊度 */
  }
}
</style>


// WEBPACK FOOTER //
// ScoreStartArmy3.vue?3d700020